import type {
  LoginResult,
  PublicModuleCatalogEntryResponse,
  RegisterRequest,
} from '@tabita/contracts';
import { apiRequest, tokenStore } from './api-client';

export const registrationApi = {
  /** The purchasable module catalog a registration wizard offers — no session required. */
  listModuleCatalog(): Promise<readonly PublicModuleCatalogEntryResponse[]> {
    return apiRequest<readonly PublicModuleCatalogEntryResponse[]>('/modules/catalog', {
      anonymous: true,
    });
  },

  /**
   * Provisions a church and, on success, an already-usable session — the
   * same tokens-stored-on-success shape `authApi.login` follows, since a
   * fresh registration never carries an MFA requirement to branch on.
   */
  async register(payload: RegisterRequest): Promise<LoginResult> {
    const response = await apiRequest<LoginResult>('/auth/register', {
      method: 'POST',
      body: payload,
      anonymous: true,
    });

    if (!('mfaRequired' in response)) {
      tokenStore.set(response.accessToken, response.refreshToken);
    }
    return response;
  },
};
